'use strict'

document.addEventListener('DOMContentLoaded', function () {
    $('.mobile-menu-btn').click(function () {
        $(this).toggleClass('active')
        $('.mobile-menu').toggleClass('active')
    })

    $(window).scroll(function () {
        if ($(this).scrollTop() > 10) {
            $('.header').addClass('header--sticky')
        } else {
            $('.header').removeClass('header--sticky')
        }
    })

    if ($('#home-video').length) {
        setTimeout(function () {
            $('#home-video').get(0).play()
            // $("video").prop('muted', false)
        }, 700)
    }
    const plusPx = window.innerWidth >= 1280 ? 400 : 0
    if ($('.landing__hello-bg').length) {
        $('.landing__hello-bg').css(
            'height',
            Math.max(
                document.body.scrollHeight + plusPx,
                document.documentElement.scrollHeight + plusPx,
                document.body.offsetHeight + plusPx,
                document.documentElement.offsetHeight + plusPx,
                document.body.clientHeight + plusPx,
                document.documentElement.clientHeight + plusPx
            )
        )
    }
    if ($('.marquee__inner').length) {
        function animateMarquee(el, duration) {
            const innerEl = el.querySelector('.marquee__inner')
            const innerWidth = innerEl.offsetWidth
            const cloneEl = innerEl.cloneNode(true)
            el.appendChild(cloneEl)

            let start = performance.now()
            let progress
            let translateX

            requestAnimationFrame(function step(now) {
                progress = (now - start) / duration

                if (progress > 1) {
                    progress %= 1
                    start = now
                }

                translateX = innerWidth * progress

                innerEl.style.transform = `translate3d(-${translateX}px, 0 , 0)`
                cloneEl.style.transform = `translate3d(-${translateX}px, 0 , 0)`
                requestAnimationFrame(step)
            })
        }

        const marquee = document.querySelector('#marquee')

        animateMarquee(marquee, 30000)
    }

    $('#subscribe').on('submit', function (e) {
        e.preventDefault()
        let email = $(this).find('.input').val()
        sendUni(email)
    })

    function sendUni(data) {
        $.ajax({
            type: 'post',
            url: 'form.php',
            data: {
                email: data,
            },
            dataType: 'json',
            beforeSend: function () {
                $('.landing__sending').addClass('active')
            },
            success: function (json) {
                $('.landing__sending').removeClass('active')
                if (json['error']) {
                    $('.landing__success').addClass('error')
                } else if (json['success']) {
                    $('.landing__success').addClass('active')
                    $('#subscribe').find('.input').val('')
                }
                setTimeout(() => {
                    $('.landing__success').removeClass('active error')
                }, 4000)
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log(error)
                $('.landing__sending').removeClass('active')
                $('.landing__success').addClass('error')
                setTimeout(() => {
                    $('.landing__success').removeClass('error')
                }, 2000)
                alert(
                    thrownError +
                        '\r\n' +
                        xhr.statusText +
                        '\r\n' +
                        xhr.responseText
                )
            },
        })
    }

    function copyTextToClipboard(text) {
        if (!navigator.clipboard) {
            fallbackCopyTextToClipboard(text)
            return
        }
        navigator.clipboard.writeText(text)
    }

    $('.contracts').click(function (e) {
        e.preventDefault()
        copyTextToClipboard(
            $(this).find('.contracts__text').attr('data-contract')
        )
        $(this).find('.contracts__text').addClass('copied')
        setTimeout(() => {
            $(this).find('.contracts__text').removeClass('copied')
        }, 1500)
    })
})
